import Modal from "./modal";

export default class ImportGrantsModal extends Modal {
  constructor(companyId) {
    super("grants-import-modal");
    this.companyId = companyId;
    this.$dropContainer = this.$modal._element.querySelector(".drop-container");
    this.$outputContainer = this.$modal._element.querySelector(
      "#import-output-container"
    );
    this.$output = this.$outputContainer.querySelector("textarea");

    this.$input = this.$modal._element.querySelector("input");
    this.setupListeners();
    this.appendVideo();
  }

  setupListeners() {
    this.$dropContainer.addEventListener("click", () => {
      this.$input.click();
    });
    this.$dropContainer.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    this.$dropContainer.addEventListener("drop", (e) => {
      e.preventDefault();
      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind === "file") {
            let file = e.dataTransfer.items[i].getAsFile();
            this.uploadFile(file);
          }
        }
      } else {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.uploadFile(e.dataTransfer.files[i]);
        }
      }
    });

    this.$input.addEventListener("change", () => {
      this.uploadFiles();
    });
  }

  appendVideo() {
    const div = document.createElement("div");
    div.innerHTML = `
            <iframe width="560" loading="lazy" height="315" src="https://www.youtube.com/embed/I_LnCIfglvw?vq=hd1080p" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            `;
    this.$modal._element
      .querySelector(".modal-footer")
      .appendChild(div.children[0]);
  }

  uploadFiles() {
    [...this.$input.files].forEach((file) => {
      this.uploadFile(file);
    });
  }

  uploadFile(file) {
    this.$output.innerText = "Uploading & parsing... Please wait";
    this.$outputContainer.classList.remove("d-none");
    const formData = new FormData();
    formData.append("company", this.companyId);
    formData.append("document", file);

    peque
      .api("grants", formData, "post")
      .then((response) => {
        this.$input.value = "";

        if (response.error > 0) {
          peque.navigation.showError(response.result);
          return;
        }

        location.reload();
      })
      .catch((response) => {
        this.$input.value = "";
        this.$output.innerHTML =
          typeof response.result === "object"
            ? response.result.join("\n\n")
            : response.result;
      });
  }
}
